import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';

export const groupStaggerFast = trigger('groupStaggerFastAnimation', [
    transition('* => *', [
        query(
            ':enter',
            [
                style({
                    opacity: 0,
                    transform: 'translateY(-10%)',
                }),
                stagger(20, [
                    group([animate(200, style({ opacity: 1 })), animate(100, style({ transform: 'translateY(0)' }))]),
                ]),
            ],
            { optional: true },
        ),

        query(
            ':leave',
            [
                style({ opacity: 1 }),
                stagger(0, [
                    group([animate(100, style({ opacity: 0 })), animate(100, style({ height: 0, minHeight: 0 }))]),
                ]),
            ],
            { optional: true },
        ),
    ]),
]);
